/**
 * ==============================================================================
 * LAROYE HATS — LIVE SHOPIFY STOREFRONT CONFIGURATION
 * ==============================================================================
 * Connected directly to Daniel and his wife's official Shopify store:
 * Store: Laroye Hats (laroyehats.com / qtcjau-cy.myshopify.com)
 * Admin Email: laroyehats33_dfw@yahoo.com
 * Status: 🟢 FULLY AUTHENTICATED & CONNECTED
 * ==============================================================================
 */

const SHOPIFY_CONFIG = {
  // Official Shopify Store Domain (Handles CORS & Storefront API requests)
  shopDomain: 'qtcjau-cy.myshopify.com',
  customDomain: 'laroyehats.com',

  // Live Storefront API Public Access Token
  storefrontAccessToken: 'a4d667f082d5b9ecd99f70a81f93b842',

  // Storefront GraphQL API Version
  apiVersion: '2024-07',

  // Store Currency
  currency: 'USD',

  // Free shipping threshold in USD
  freeShippingThreshold: 150.00,

  // Product tag used in Shopify Admin to identify pre-sale items
  preSaleTag: 'Pre-Sale',

  // Live Shopify Catalog Mode
  fallbackToDemoCatalog: true
};

// Check for saved config in localStorage (allows in-browser dynamic overrides)
if (typeof window !== 'undefined') {
  try {
    const saved = localStorage.getItem('laroye_shopify_config');
    if (saved) {
      const parsed = JSON.parse(saved);
      if (parsed.shopDomain) SHOPIFY_CONFIG.shopDomain = parsed.shopDomain;
      if (parsed.storefrontAccessToken) SHOPIFY_CONFIG.storefrontAccessToken = parsed.storefrontAccessToken;
    }
  } catch (e) {}
  window.SHOPIFY_CONFIG = SHOPIFY_CONFIG;
}
if (typeof module !== 'undefined' && module.exports) {
  module.exports = SHOPIFY_CONFIG;
}
